// 10357252 -> "9.9 MB". Shown next to every PDF link: these files are up to 10 MB
// and many visitors are on mobile data.
export const formatSize = (bytes: number) =>
  bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
